export default "__VITE_ASSET__k0AYGOX9__"